import { Stack, Typography } from "@mui/material";
import { ArrowSquareOutIcon } from "@phosphor-icons/react";
import { RESUME } from "../../enums/sourceEnums";

export const ResumeButton = () => {
  return (
    <Stack direction={'row'} gap={1} sx={{ cursor: 'pointer' }} onClick={() => window.open(RESUME, '_blank')}>
      <Typography fontWeight={700} fontSize={'14px'}>Resume</Typography>
      <ArrowSquareOutIcon size={20} weight="bold" />
    </Stack>
  );
}